import { configNoHeaders } from '@api/constructor-api'

// Convert Aliase of restaurant and branch to UUID
function convertAliaseHandler(payload) {
  return configNoHeaders(async (API) => {
    return API.get('aliases', { params: payload });
  });
}

export {
  convertAliaseHandler,
}
